import Vue from 'vue'
import {
  ActionSheet,
  AddressEdit,
  AddressList,
  Area,
  Button,
  Card,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Grid, 
  GridItem,
   Circle,
  // Col,
   Collapse,
   CollapseItem,
  // ContactCard,
  // ContactEdit,
  // ContactList,
  // Coupon,
  // CouponCell,
  // CouponList,
  DatetimePicker,
  Dialog,
  Divider,
  Field,
   GoodsAction,
  GoodsActionButton,
   GoodsActionIcon,
  Icon,
  Image,
  ImagePreview,
  // Info,
  Lazyload,
  List,
  Loading,
  Locale,
  NavBar,
  // NoticeBar,
  Notify,
  NumberKeyboard,
  Overlay,
  // Pagination,
  // Panel,
  PasswordInput,
  Picker,
  Popup,
   Progress,
  PullRefresh,
  Radio,
  RadioGroup,
   Rate,
  // Row,
  Search,
  Sticky,
  // Sku,
  Slider,
  // Sidebar,
  // SidebarItem ,
   Step,
  Stepper,
  Steps,
  SubmitBar,
  Swipe,
  SwipeCell,
  SwipeItem,
  Switch,
  SwitchCell,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  // Tag,
  Toast,
  // TreeSelect,
   Uploader
} from 'vant'

Vue.use(ActionSheet)
  .use(AddressEdit)
  .use(AddressList)
  .use(Area)
  .use(Button)
  .use(Card)
  .use(Cell)
  .use(CellGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Grid)
  .use(GridItem)
   .use(Circle)
  // .use(Col)
   .use(Collapse)
   .use(CollapseItem)
  // .use(ContactCard)
  // .use(ContactEdit)
  // .use(ContactList)
  // .use(Coupon)
  // .use(CouponCell)
  // .use(CouponList)
  .use(DatetimePicker)
  .use(Divider )
  .use(Dialog)
  .use(Field)
   .use(GoodsAction)
   .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Icon)
  .use(Image)
  .use(ImagePreview)
  // .use(Info)
  .use(Lazyload)
  .use(List)
  .use(Loading)
  .use(Locale)
  .use(NavBar)
  // .use(NoticeBar)
  .use(Notify)
  .use(NumberKeyboard)
  .use(Overlay)
  // .use(Pagination)
  // .use(Panel)
  .use(PasswordInput)
  .use(Picker)
  .use(Popup)
   .use(Progress)
  .use(PullRefresh)
  .use(Radio)
  .use(RadioGroup)
  .use(Rate)
  // .use(Row)
  .use(Search)
  // .use(Sku)
  .use(Slider)
   .use(Step)
  .use(Sticky)
  .use(Stepper)
  .use(Steps)
  .use(SubmitBar)
  // .use(Sidebar)
  // .use(SidebarItem )
  .use(Swipe)
  .use(SwipeCell)
  .use(SwipeItem)
  .use(Switch)
  .use(SwitchCell)
  .use(Tab)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Tabs)
  // .use(Tag)
  .use(Toast)
  // .use(TreeSelect)
 .use(Uploader)



// WEBPACK FOOTER //
// ./src/vantUI/index.js